import { createSelector } from 'reselect'
import * as objectTypes from '../constants/objectTypes'

const getNodes = state => state.entities.nodes

export const getShops = createSelector(
    [getNodes],
    nodes => Object.keys(nodes)
                .filter(key => nodes[key].type !== objectTypes.NODE)
                .reduce((acc, key) => {
                    acc[key] = nodes[key]
                    return acc
                }, {})
)

export const getPictograms = createSelector(
    [getNodes],
    nodes => Object.keys(nodes)
        .filter(key => nodes[key].type === objectTypes.ELEVATOR || nodes[key].type === objectTypes.ESCALATOR || nodes[key].type === objectTypes.STAIRS || nodes[key].type === objectTypes.BABY || nodes[key].type === objectTypes.BABY_BOTTLE || nodes[key].type === objectTypes.HANDICAP || nodes[key].type === objectTypes.TOILET || nodes[key].type === objectTypes.INFO)
        .map(key => nodes[key])
)


// WEBPACK FOOTER //
// ./selectors/index.js